function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 15.5,
  r: 15.5,
  fill: "#173859"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6752 10.2478C15.8338 10.4064 15.9229 10.6216 15.9229 10.846C15.9229 11.0704 15.8338 11.2856 15.6752 11.4443L12.0425 15.0769L15.6752 18.7096C15.8293 18.8692 15.9146 19.0829 15.9127 19.3048C15.9107 19.5266 15.8217 19.7389 15.6649 19.8958C15.508 20.0526 15.2957 20.1416 15.0739 20.1436C14.852 20.1455 14.6383 20.0602 14.4787 19.9061L10.2478 15.6752C10.0891 15.5165 10 15.3013 10 15.0769C10 14.8525 10.0891 14.6373 10.2478 14.4787L14.4787 10.2478C14.6373 10.0891 14.8525 10 15.0769 10C15.3013 10 15.5165 10.0891 15.6752 10.2478ZM20.7522 10.2478C20.9109 10.4064 21 10.6216 21 10.846C21 11.0704 20.9109 11.2856 20.7522 11.4443L17.1196 15.0769L20.7522 18.7096C20.9064 18.8692 20.9917 19.0829 20.9898 19.3048C20.9878 19.5266 20.8988 19.7389 20.7419 19.8958C20.5851 20.0526 20.3728 20.1416 20.151 20.1436C19.9291 20.1455 19.7153 20.0602 19.5557 19.9061L15.3248 15.6752C15.1662 15.5165 15.0771 15.3013 15.0771 15.0769C15.0771 14.8525 15.1662 14.6373 15.3248 14.4787L19.5557 10.2478C19.7144 10.0891 19.9296 10 20.154 10C20.3784 10 20.5936 10.0891 20.7522 10.2478Z",
  fill: "white"
});
function SvgArrowsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsMenu);
export default __webpack_public_path__ + "static/media/Arrows Menu.3e7673860f1acab8bcb909580bde3280.svg";
export { ForwardRef as ReactComponent };